export const BreadcrumbIcon = ({
    width = 16,
    height = 16,
    color = "#1D201E",
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
    >
        <rect
            width={width}
            height={height}
            fill="white"
            fill-opacity="0.01"
        />
        <path
            d="M11 8L6.00005 13L5.30005 12.3L9.60005 8L5.30005 3.7L6.00005 3L11 8Z"
            fill={color}
        />
    </svg>
);
